export const RenderIf = ({ children, isTrue }: { children: any; isTrue: any }) => {
    return isTrue ? children : null;
};
